if (!customElements.get('b2b-gift-occasions')) {
  class B2bGiftOccasions extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabsNav = this.querySelector('[data-tabs-nav]');
      this.tabsWrap = this.querySelector('.b2b-occasions__tabs-wrap');

      if (!this.tabs.length || !this.panels.length) return;

      this.tabs.forEach((tab, index) => {
        tab.setAttribute('data-index', String(index));
        tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        tab.setAttribute('tabindex', index === 0 ? '0' : '-1');

        if (tab.id && this.panels[index]) {
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          tab.setAttribute('aria-controls', this.panels[index].id);
        }

        tab.addEventListener('click', (event) => {
          event.preventDefault();
          this.setActiveTab(index);
        });

        tab.addEventListener('keydown', (event) => this.handleKeyDown(event, index));
      });

      this.panels.forEach((panel, index) => {
        panel.hidden = index !== 0;
        panel.setAttribute('tabindex', '0');
      });

      this.selectedIndex = 0;
      this.initTabsScrollHint();

      if (window.Shopify?.designMode) {
        this.onBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          const tab = event.target.closest('[role="tab"]');
          if (!tab) return;
          const index = Number(tab.dataset.index);
          if (!Number.isNaN(index)) this.setActiveTab(index);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      if (this.onBlockSelect) {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      this.tabsNav?.removeEventListener('scroll', this.onTabsScroll);
      this.tabsResizeObserver?.disconnect();
      window.removeEventListener('resize', this.onTabsResize);
    }

    initTabsScrollHint() {
      if (!this.tabsNav || !this.tabsWrap) return;

      this.onTabsScroll = () => this.updateTabsScrollHint();
      this.onTabsResize = () => this.updateTabsScrollHint();

      this.tabsNav.addEventListener('scroll', this.onTabsScroll, { passive: true });
      window.addEventListener('resize', this.onTabsResize);

      if (typeof ResizeObserver !== 'undefined') {
        this.tabsResizeObserver = new ResizeObserver(() => this.updateTabsScrollHint());
        this.tabsResizeObserver.observe(this.tabsNav);
      }

      this.updateTabsScrollHint();
      requestAnimationFrame(() => this.updateTabsScrollHint());
    }

    updateTabsScrollHint() {
      if (!this.tabsNav || !this.tabsWrap) return;

      const maxScroll = this.tabsNav.scrollWidth - this.tabsNav.clientWidth;
      const scrollLeft = this.tabsNav.scrollLeft;
      const canScroll = maxScroll > 2;

      this.tabsWrap.classList.toggle('is-scrollable-left', canScroll && scrollLeft > 2);
      this.tabsWrap.classList.toggle('is-scrollable-right', canScroll && scrollLeft < maxScroll - 2);
    }

    handleKeyDown(event, index) {
      let nextIndex = index;

      if (event.key === 'ArrowRight') {
        nextIndex = (index + 1) % this.tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.setActiveTab(nextIndex);
      this.tabs[nextIndex]?.focus();
    }

    setActiveTab(index) {
      if (index < 0 || index >= this.tabs.length || index === this.selectedIndex) return;

      const previousIndex = this.selectedIndex;
      this.selectedIndex = index;

      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== index;
      });

      this.tabs[index]?.scrollIntoView({
        behavior: 'smooth',
        inline: 'nearest',
        block: 'nearest'
      });
      this.updateTabsScrollHint();

      this.dispatchEvent(
        new CustomEvent('tabChange', {
          bubbles: true,
          detail: {
            selectedIndex: index,
            previousIndex,
            selectedTab: this.panels[index]
          }
        })
      );
    }
  }

  customElements.define('b2b-gift-occasions', B2bGiftOccasions);
}
